import { string, object } from 'yup'

export async function validateEmail(email) {
  let validEmail = false

  const validationSchema = object().shape({
    email: string().email().required(true),
  })

  await validationSchema.isValid({ email }).then(valid => (validEmail = valid))

  return validEmail
}
